angular.module('leanlaw').controller('ClientMatterRevenueInvoicesCtrl', ['$scope', '$window', '$timeout', '$q', '$filter', '$rootScope', '$stateParams', "alerts", 'userService', 'reportsService', 'leanLawAuth', 'singleRequest', 'accountingService', "exportJson", "messageBus", 'ModalService', 'viewInvoiceService', function ($scope, $window, $timeout, $q, $filter, $rootScope, $stateParams, alerts, userService, reportsService, leanLawAuth, singleRequest, accountingService, exportJson, messageBus, ModalService, viewInvoiceService) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    $window.print();
  };
  $scope.showInvoice = showInvoice;
  $scope.showDraft = showDraft;
  $scope.openInvoice = openInvoice;
  $scope.openPayment = openPayment;
  $scope.showAllocation = showAllocation;
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.reduce((accum, c) => {
      let item = {
        "Client": c.client.name,
        [matter]: "",
        "Collected": $filter("amount")(c.data.collected.servicesTotal)
      };
      item["Share"] = $filter("amount")(c.data.origination.share);
      if ($scope.data.data.origination.debit) {
        item["Origination"] = $filter("amount")(c.data.origination.debit);
        item["Adjusted Share"] = $filter("amount")(c.data.origination.adjusted);
      }
      ;
      accum.push(item);
      if ($scope.filter.include.matters) {
        c.matters.forEach(m => {
          let item = {
            "Client": "",
            [matter]: m.matter.name,
            "Collected": $filter("amount")(m.data.collected.servicesTotal)
          };
          item["Share"] = $filter("amount")(m.data.origination.share);
          if ($scope.data.data.origination.debit) {
            item["Origination"] = $filter("amount")(m.data.origination.debit);
            item["Adjusted Share"] = $filter("amount")(m.data.origination.adjusted);
          }
          ;
          accum.push(item);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let _cancelReport = null;
  function filterClientEntries() {
    if (_cancelReport) {
      _cancelReport.resolve("reloading");
    }
    _cancelReport = $q.defer();
    var query = reportsService.queryFromFilter($scope.filter);
    query.data = "payments";
    query.billed = 'any';
    query.billedState = undefined;
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.detail = 'payments';
    query.reportType = "revenue";
    query.$timeout = _cancelReport.promise;
    query.clientId = $stateParams.clientId;
    query.matterId = $stateParams.matterId;
    $scope.loading = true;
    singleRequest.apiCall("report").getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      const invoicePayments = [];
      $scope.data = data;
      data.clients.forEach(client => {
        client.data.detail.invoicePayments.forEach(ip => {
          invoicePayments.push({
            id: ip.id,
            amount: ip.amount,
            invoice: ip.invoice,
            payment: ip.payment,
            client: client.client,
            data: ip.data
          });
        });
      });
      $scope.data.invoicePayments = invoicePayments;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  function showInvoice(invoice) {
    const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
    $window.open(url);
  }
  function showDraft(invoice) {
    viewInvoiceService.viewInvoice(invoice, false);
  }
  function showAllocation(invoicePayment) {
    $timeout(() => {
      $(".modal-backdrop.in").remove();
      // This won't flash because the backdrop is hidden
      // This simply removes the elements so they don't stack up once
      // the body doesn't have the "show-modal-overlay" class
    }, 50);
    return ModalService.showModal({
      template: require("../../../modals/allocation/template.html"),
      inputs: {
        params: {
          invoicePayment
        }
      },
      bodyClass: "show-modal-overlay",
      controller: "AllocationModalController"
    }).then(modal => {
      modal.element.modal();
      modal.close.then(() => {
        // Remove modal-open class from body which breaks print
        $("body").removeClass("modal-open");
      });
    });
  }
  function openInvoice(invoice) {
    var url = `${$scope.me.configuration.quickbooks}/app/invoice?txnId=${invoice.accounting.id}`;
    window.open(url, '_blank');
  }
  function openPayment(payment) {
    var url = `${$scope.me.configuration.quickbooks}/app/recvpayment?txnId=${payment.accounting.id}`;
    window.open(url, '_blank');
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.invoicePayments, $scope.q), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.invoicePayments', updateFiltered);
  $scope.$watch('q', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);